module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/router-e89a898903910a3ac4422739c4c9143c.png";